import styled from 'styled-components';

import {Overlay as BaseOverlay} from '../Dropdown';

export const DropdownOverlay = styled(BaseOverlay)`
  max-height: 300px;
  overflow: hidden auto;
  padding: 0;
`;
